var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1C9.748 1 1 9.748 1 20.5S9.748 40 20.5 40C31.253 40 40 31.252 40 20.5S31.253 1 20.5 1zm0 40C9.196 41 0 31.802 0 20.5 0 9.196 9.196 0 20.5 0 31.803 0 41 9.196 41 20.5 41 31.803 31.803 41 20.5 41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.158 17.452h1.86v-1.808c0-.798.02-2.028.6-2.79.61-.806 1.448-1.354 2.889-1.354 2.347 0 3.335.334 3.335.334l-.465 2.758s-.775-.226-1.498-.226c-.725 0-1.373.26-1.373.984v2.102h2.968l-.207 2.693h-2.76V29.5h-3.489v-9.355h-1.86v-2.693"
  }))));
};
export default SvgFacebook;